
import { defineComponent, PropType } from "vue";

import {
  BaseButton,
  DeleteIcon,
  SouthIcon,
  NorthIcon,
  FormField,
} from "@tager/admin-ui";

import { moveItem } from "@/views/BasisProductForm/BasisProductForm.helpers";
import { BasisProductParam } from "@/typings/model";
import OptionTable from "@/views/BasisProductForm/components/components/OptionTable.vue";

type Props = Readonly<{
  params: Array<BasisProductParam>;
}>;
export default defineComponent({
  name: "ParamBlock",
  components: {
    OptionTable,
    BaseButton,
    DeleteIcon,
    SouthIcon,
    NorthIcon,
    FormField,
  },
  props: {
    params: {
      type: Array as PropType<Props["params"]>,
      required: true,
    },
  },
  setup(props) {
    function removeField(rowIndex: number) {
      props.params.splice(rowIndex, 1);
    }

    function handleClick(
      itemList: Array<BasisProductParam>,
      itemIndex: number,
      direction: "up" | "down"
    ) {
      moveItem<BasisProductParam>(itemList, itemIndex, direction);
    }

    return {
      removeField,
      handleClick,
    };
  },
});
